export const APPLICATION_ROOT_ID = 'root'
